import React from 'react';
import {RiFileCopyLine} from 'react-icons/ri';
import { userHasAccess } from '../../../supplementary_components/userDataDelegate';
import { Link } from 'react-router-dom';
import styles from './informationCard.module.scss';

// Re-export for OverviewCard
export const EditableSection = ({ children, $smallerfont, className = '', infoCard }) => (
  <div className={`${styles.editableSection} ${$smallerfont ? styles.compact : ''} ${className} ${!infoCard||styles.infoCardSection}`}>
    {children}
  </div>
);
const getStatusBadgeStyle = (status) => {
  if (!status) return {};
  const style = {};
  if (status.colorCode) style.backgroundColor = `rgba(${status.colorCode}, 1)`;
  if (status.bgColor) style.backgroundColor = status.bgColor;
  if (status.textColor){
    style.color = status.textColor;
  }else{
    style.color = "white";
  }
  style.fontWeight = "700";
  return style;
};

const getSectionAccess = (section) => {
  const canView =
    !section.visibilityAndEditAccessLevel || userHasAccess(section.visibilityAndEditAccessLevel);

  let canEdit = false;
  if (section.editButton) {
    if (section.visibilityAndEditAccessLevel) {
      canEdit = canView;
    } else if (section.editAccessLevel) {
      canEdit = userHasAccess(section.editAccessLevel);
    }
  }

  return { canView, canEdit };
};

const renderHeaderTitlePart = (header, value) => {
  if (!value) return null;
  if (!header.titlePath) return value;
  return (
    <Link
      to={header.titlePath}
      className={styles.clickableHeaderTitle}
      onClick={() => header.onTitleNavigate?.()}
    >
      {value}
    </Link>
  );
};

export const InformationCard = ({ object, selectedObject, setData }) => {
  return (
    <div className={styles.infoCard}>
      <div className={`${styles.pageHeader} ${object.popup ? styles.compact : ''}`}>
        <div className={styles.mainTitle}>
          <span>
            {object.header.title}
            {renderHeaderTitlePart(object.header, object.header.titleSuffix)}
            <br />
            {renderHeaderTitlePart(object.header, object.header.titleVal)}
          </span>
          {object.header.status ? (
            <span style={getStatusBadgeStyle(object.header.status)}>
              {object.header.status.value}
            </span>
          ) : null}
        </div>        
        <div className={styles.suplementaryInfo}>
          {object.header.suplementaryInfo}
          
        </div>
      </div>
      {object.infoSections.map((section, index) => {
        const { canView, canEdit } = getSectionAccess(section);
        if (!canView) return null;

        const showActions = (section.editButton && canEdit) || section.copyButton;

        return (
        <EditableSection key={section.title + index} $smallerfont={object.popup} infoCard={true}>
          <div className={section.editButton || section.copyButton ? styles.sectionHeader : styles.componentTitle}>
            <span className={styles.sectionTitleText}>{section.title}</span>
            {showActions ? (
              <div className={styles.sectionActions}>
                {section.copyButton ? (
                  <RiFileCopyLine className={styles.copyButton} onClick={section.copyButton} />
                ) : null}
                {section.editButton && canEdit ? (
                  <button onClick={(e) => section.editButton.action(setData, e)}>
                    {section.editButton.text}
                  </button>
                ) : null}
              </div>
            ) : null}
          </div>
          {LabeledItemsList(section, object, selectedObject, styles, setData)}
        </EditableSection>
        );
      })}
    </div>
  );
};


const renderColumnValue = (column, selectedObject, object, setData) => {
    const SubValueComponent = column.subValueComponent;
    
    if(SubValueComponent){
        if(!selectedObject){
          selectedObject = object;
        }
        // Backwards compatible:
        // - legacy: (selectedObject, columnName) => ReactNode
        // - component: (props) => ReactNode (may use hooks)
        if(typeof(SubValueComponent) === 'function' && SubValueComponent.length >= 2){
            return SubValueComponent(selectedObject, column.subValueColumnName);
        }
        return <SubValueComponent val={selectedObject} name={column.subValueColumnName} column={column} setData={setData} />;
    }
    if(column.clickable && column.clickable.path){
        return <Link to={column.clickable.path}>{column.val}</Link>;
    }
    return column.val;
}

const LabeledItemsList = (section, object, selectedObject, styleModule, setData) => {
  if (section.columns === undefined) return <></>;

  return (
    <div>
      {section.columns.map((column, index) => {
        if (!column || column.hiddenInInfoCard || column.customDisplayMode === "none") return null;
        return (
          <div key={column.label + index}>
            <div className={`${styleModule.label} ${object.popup ? styleModule.compact : ''}`}>
              {column.label}
            </div>
            <div className={`${styleModule.value} ${object.popup ? styleModule.compact : ''}`}>
              {renderColumnValue(column, selectedObject, object, setData)}
            </div>
          </div>
        );
      })}
    </div>
  );
};
